import { Text } from "./Parse";

export const text = ({ content }: Text): HTML => content;
